var RGX = /{{(.*?)}}/g;

module.exports = function (str, mix) {
  return str.replace(RGX, function (x, key, y) {
    x = 0;
    y = mix;
    key = key.trim().split('.');

    while (y && x < key.length) {
      y = y[key[x++]];
    }

    return y != null ? y : '';
  });
};